module.exports = __webpack_public_path__ + "static/media/Tekion_logo.75fe62df.png";